import React from 'react'
import { ActionLink } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/ActionLink'
import styles from 'modules/Services/Network/subcomponents/AccountsList/account-list.module.scss'
import { MainActionButton } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/MainActionButton'
import { Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const FinanceColumn = ({
  row: {
    original: { main_action, extra_actions, extra_info, id, login, auto_replenishment },
  },
  networkType,
  i18n,
}) => {
  const isAutoReplenish = extra_actions.findIndex((action) => action === 'auto_replenish') > -1

  return (
    <Grid
      gap={16}
      justifyContent={'start'}
      alignItems={'center'}
      wrap={false}
      direction={'row'}
    >
      <MainActionButton
        id={id}
        main_action={main_action}
        i18n={i18n}
        type={networkType}
      />
      {isAutoReplenish && (
        <ActionLink
          hideLabel={true}
          className={styles['accounts-list__action-link']}
          action={'auto_replenish'}
          login={login}
          id={id}
          type={networkType}
          i18n={i18n}
          auto_replenishment={auto_replenishment}
          extra_info={extra_info}
        />
      )}
    </Grid>
  )
}

export default FinanceColumn

FinanceColumn.propTypes = {
  row: PropTypes.object.isRequired,
  networkType: PropTypes.string.isRequired,
  i18n: PropTypes.string.isRequired,
}
